import { Avatar, Box, InitialsInCircle, spaces } from '@electricjs/arc';

import { getHRISLogo } from 'common/Notification/helpers/notificationHelpers';
import { NotificationIcon } from '../NotificationIcon';

type HRISXboardingNotificationIconProps = {
  name?: string;
  size?: string;
  avatarSize?: string;
  isNotificationUnseen?: boolean;
  loading?: boolean;
};

const HRISXboardingNotificationIcon = ({
  name = 'HRIS',
  size = '4rem',
  avatarSize = '2rem',
  isNotificationUnseen = false,
  loading = false,
}: HRISXboardingNotificationIconProps) => {
  const logo = getHRISLogo(name);

  const icon = !logo ? (
    <InitialsInCircle text={name} size={size} />
  ) : (
    <Box pt={spaces.space_xs} pl={spaces.space_3xs} pr={spaces.space_2xs}>
      <Avatar
        src={logo}
        alt={name}
        size={avatarSize}
        borderRadius="0"
        backgroundColor="transparent"
      />
    </Box>
  );

  return (
    <NotificationIcon
      isNotificationUnseen={isNotificationUnseen}
      loading={loading}
      icon={icon}
    />
  );
};

export default HRISXboardingNotificationIcon;
